// @flow

/**
 * Module dependencies.
 */

import { Col, ColFlex, Row, RowFlex } from 'client/components/core/grid';
import { Separator } from 'client/components/separator';
import { colors, media, units } from 'client/styles';
import Icon from 'client/components/core/icon';
import Layout from 'client/components/core/layout';
import RawHtml from 'react-raw-html';
import React from 'react';
import Text from 'client/components/core/type';

/**
 * `Props` type.
 */

type Props = {
  text: string,
  title: string
};

/**
 * Icon style.
 */

const iconStyle = `
  svg {
    margin-left: -15%;
    max-height: 538px;
    width: 130%;
  }

  ${media.min.sm`
    svg {
      width: 100%;
      margin-left: 0;
    }
  `}
`;

/**
 * Render icon.
 */

function renderIcon(styles: string = ''): React$Element<*> {
  return (
    <Icon
      icon={'illustration-world-pins'}
      size={'100%'}
      styles={styles}
    />
  );
}

/**
 * `Expanding` component.
 */

function Expanding(props: Props): React$Element<*> {
  const { text, title } = props;

  return (
    <Layout
      overflow={'hidden'}
      paddingVertical={units(8)}
      paddingVerticalLg={units(0)}
    >
      <RowFlex>
        <ColFlex
          sm={5}
          xs={10}
          xsOffset={1}
        >
          <Layout
            marginBottomMd={units(6)}
            marginBottomSm={units(4)}
            maxWidth={units(60)}
          >
            <Text.H2
              color={colors.brandPrimary}
              marginBottom={units(0)}
            >
              {title}
            </Text.H2>

            <Layout displaySm={'none'}>
              {renderIcon(iconStyle)}
            </Layout>
          </Layout>

          <Row>
            <Col
              smHidden
              xs={2}
              xsHidden
            >
              <Separator.Horizontal topRight/>
            </Col>

            <Col
              md={10}
              xs={12}
            >
              <Text.Paragraph>
                <RawHtml.span>
                  {text}
                </RawHtml.span>
              </Text.Paragraph>
            </Col>
          </Row>
        </ColFlex>

        <ColFlex
          md={5}
          xs={6}
          xsHidden
        >
          {renderIcon(iconStyle)}
        </ColFlex>
      </RowFlex>
    </Layout>
  );
}

/**
 * Export `Expanding`.
 */

export default Expanding;



// WEBPACK FOOTER //
// ../src/client/components/licensed-representatives/expanding.js